import { ErrorInfo } from "react";
import { fetchService } from "./fetchService";
import * as API_PATHS from "utility/api-paths";
import { AddUserToPodFormData, OnboardingRequestItem, PodItem, PodOnboardingRequestBody, RequestDetails, RoleItem } from "utility/types";

export const getPods = async (teamName?: string): Promise<{ result: Array<PodItem>} > => {
  try {
    const url = teamName
      ? `${API_PATHS.GET_PODS}?team_name=${encodeURIComponent(teamName)}`
      : API_PATHS.GET_PODS;
    const data = await fetchService<{ result: Array<PodItem> }>(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return data;
  } catch (error: any) {
    throw error;
  }
};

export const getRoles = async (): Promise<Array<RoleItem> | ErrorInfo> => {
  try {
    const data = await fetchService<Array<RoleItem>>(API_PATHS.GET_ROLES, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return data;
  } catch (error: any) {
    throw error;
  }
};

export const addUserToPod = async (
  formData: AddUserToPodFormData
): Promise<Array<RoleItem> | ErrorInfo> => {
  try {
    const data = await fetchService<Array<RoleItem>>(
      API_PATHS.ADD_USER_TO_POD,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: formData,
      }
    );
    return data;
  } catch (error: any) {
    throw error;
  }
};

export const getRequestList = async (
  email: string,
  role: string
): Promise<Array<OnboardingRequestItem> | ErrorInfo> => {
  try {
    const data = await fetchService<{ user_details: Array<OnboardingRequestItem> }>(
      `${API_PATHS.GET_REQUESTS}/${email}/${role}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return data.user_details;
  } catch (error: any) {
    throw error;
  }
};

export interface PaginatedRequestsParams {
  email: string;
  role: string;
  page?: number;
  page_size?: number;
  request_number?: string;
  raised_by?: string;
  raised_for?: string;
  status?: string;
  onboarding_type?: string;
  sort_by?: string;
  sort_order?: "asc" | "desc";
}

export interface PaginatedRequestsResponse {
  user_details: Array<OnboardingRequestItem>;
  total_count: number;
  page: number;
  page_size: number;
  total_pages: number;
  has_next: boolean;
  has_previous: boolean;
}

export const getRequestListPaginated = async (
  params: PaginatedRequestsParams
): Promise<PaginatedRequestsResponse | ErrorInfo> => {
  try {
    // Build query string from params
    const queryParams = new URLSearchParams();
    if (params.page) { queryParams.append("page", params.page.toString()); }
    if (params.page_size) { queryParams.append("page_size", params.page_size.toString()); }
    if (params.request_number) { queryParams.append("request_number", params.request_number); }
    if (params.raised_by) { queryParams.append("raised_by", params.raised_by); }
    if (params.raised_for) { queryParams.append("raised_for", params.raised_for); }
    if (params.status) { queryParams.append("status", params.status); }
    if (params.onboarding_type) { queryParams.append("onboarding_type", params.onboarding_type); }
    if (params.sort_by) { queryParams.append("sort_by", params.sort_by); }
    if (params.sort_order) { queryParams.append("sort_order", params.sort_order); }

    const encodedEmail = encodeURIComponent(params.email);
    const encodedRole = encodeURIComponent(params.role);
    const url = `${API_PATHS.GET_REQUESTS_PAGINATED}/${encodedEmail}/${encodedRole}?${queryParams.toString()}`;
    
    const data = await fetchService<PaginatedRequestsResponse>(
      url,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return data;
  } catch (error: any) {
    throw error;
  }
};

export const getRequestDetails = async (
  request: { requestId: string }
): Promise<RequestDetails | ErrorInfo> => {
  try {
    const data = await fetchService<RequestDetails>(
      `${API_PATHS.GET_REQUEST_DETAILS}/${request.requestId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return data;
  } catch (error: any) {
    throw error;
  }
};

export const addUserToAzureGroup = async (
  body: { user_id: string, group_id: string }
): Promise<RequestDetails | ErrorInfo | undefined> => {
  try {
    const data = await fetchService<RequestDetails>(
      `${API_PATHS.ADD_USER_TO_AZURE_GROUP}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: body
      }
    );
    return data;
  } catch (error: any) {
    // throw error;
    console.log("error", error)
  }
};

export const addUserToSagemaker = async (
  body: { email: string, team_name: string }
): Promise<RequestDetails | ErrorInfo  | undefined> => {
  try {
    const data = await fetchService<RequestDetails>(
      `${API_PATHS.SAGEMAKER_ADD_USER}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: body
      }
    );
    return data;
  } catch (error: any) {
    // throw error;
    console.log("error", error)
  }
};

export const podOnboarding = async (
  body: PodOnboardingRequestBody
): Promise<{} | ErrorInfo  | undefined> => {
  try {
    const data = await fetchService<RequestDetails>(
      `${API_PATHS.POD_ONBOARDING}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: body
      }
    );
    return data;
  } catch (error: any) {
    // throw error;
    console.log("error", error)
  }
};
